export default () => ({
	/**
	 * Settings for CoverGo Studio app
	 * NOTE: Should come from the backend eventually, hardcoded for now
	 */
	settings: {
		// we use dayjs syntax: https://github.com/iamkun/dayjs/blob/master/docs/en/API-reference.md#format-formatstringwithtokens-string
		dateFormat: "DD/MM/YYYY",
		dateTimeFormat: "DD/MM/YYYY HH:mm:ss",

		// NOTE: For localization of things we display this dictionary
		// Each tenant can have their own dictionary, we provide solid default

		// List follows BCP47 standards and comes from paypal locale
		// https://developer.paypal.com/docs/api/reference/locale-codes/#supported-locale-codes

		localesDictionary: [
			{ name: "en-US", value: "en-US" },
			{ name: "zh-HK", value: "zh-HK" },
			{ name: "en-HK", value: "en-HK" },
			{ name: "en-AL", value: "en-AL" },
			{ name: "ar-DZ", value: "ar-DZ" },
			{ name: "en-DZ", value: "en-DZ" },
			{ name: "fr-DZ", value: "fr-DZ" },
			{ name: "es-DZ", value: "es-DZ" },
			{ name: "zh-DZ", value: "zh-DZ" },
			{ name: "en-AD", value: "en-AD" },
			{ name: "fr-AD", value: "fr-AD" },
			{ name: "es-AD", value: "es-AD" },
			{ name: "zh-AD", value: "zh-AD" },
			{ name: "en-AO", value: "en-AO" },
			{ name: "fr-AO", value: "fr-AO" },
			{ name: "es-AO", value: "es-AO" },
			{ name: "zh-AO", value: "zh-AO" },
			{ name: "en-AI", value: "en-AI" },
			{ name: "fr-AI", value: "fr-AI" },
			{ name: "es-AI", value: "es-AI" },
			{ name: "zh-AI", value: "zh-AI" },
			{ name: "en-AG", value: "en-AG" },
			{ name: "fr-AG", value: "fr-AG" },
			{ name: "es-AG", value: "es-AG" },
			{ name: "zh-AG", value: "zh-AG" },
			{ name: "es-AR", value: "es-AR" },
			{ name: "en-AR", value: "en-AR" },
			{ name: "en-AM", value: "en-AM" },
			{ name: "fr-AM", value: "fr-AM" },
			{ name: "es-AM", value: "es-AM" },
			{ name: "zh-AM", value: "zh-AM" },
			{ name: "en-AW", value: "en-AW" },
			{ name: "fr-AW", value: "fr-AW" },
			{ name: "es-AW", value: "es-AW" },
			{ name: "zh-AW", value: "zh-AW" },
			{ name: "en-AU", value: "en-AU" },
			{ name: "de-AT", value: "de-AT" },
			{ name: "en-AT", value: "en-AT" },
			{ name: "en-AZ", value: "en-AZ" },
			{ name: "fr-AZ", value: "fr-AZ" },
			{ name: "es-AZ", value: "es-AZ" },
			{ name: "zh-AZ", value: "zh-AZ" },
			{ name: "en-BS", value: "en-BS" },
			{ name: "fr-BS", value: "fr-BS" },
			{ name: "es-BS", value: "es-BS" },
			{ name: "zh-BS", value: "zh-BS" },
			{ name: "ar-BH", value: "ar-BH" },
			{ name: "en-BH", value: "en-BH" },
			{ name: "fr-BH", value: "fr-BH" },
			{ name: "es-BH", value: "es-BH" },
			{ name: "zh-BH", value: "zh-BH" },
			{ name: "en-BB", value: "en-BB" },
			{ name: "fr-BB", value: "fr-BB" },
			{ name: "es-BB", value: "es-BB" },
			{ name: "zh-BB", value: "zh-BB" },
			{ name: "en-BY", value: "en-BY" },
			{ name: "en-BE", value: "en-BE" },
			{ name: "nl-BE", value: "nl-BE" },
			{ name: "fr-BE", value: "fr-BE" },
			{ name: "es-BZ", value: "es-BZ" },
			{ name: "en-BZ", value: "en-BZ" },
			{ name: "fr-BZ", value: "fr-BZ" },
			{ name: "zh-BZ", value: "zh-BZ" },
			{ name: "fr-BJ", value: "fr-BJ" },
			{ name: "en-BJ", value: "en-BJ" },
			{ name: "es-BJ", value: "es-BJ" },
			{ name: "zh-BJ", value: "zh-BJ" },
			{ name: "en-BM", value: "en-BM" },
			{ name: "fr-BM", value: "fr-BM" },
			{ name: "es-BM", value: "es-BM" },
			{ name: "zh-BM", value: "zh-BM" },
			{ name: "en-BT", value: "en-BT" },
			{ name: "es-BO", value: "es-BO" },
			{ name: "en-BO", value: "en-BO" },
			{ name: "fr-BO", value: "fr-BO" },
			{ name: "zh-BO", value: "zh-BO" },
			{ name: "en-BA", value: "en-BA" },
			{ name: "en-BW", value: "en-BW" },
			{ name: "fr-BW", value: "fr-BW" },
			{ name: "es-BW", value: "es-BW" },
			{ name: "zh-BW", value: "zh-BW" },
			{ name: "pt-BR", value: "pt-BR" },
			{ name: "en-BR", value: "en-BR" },
			{ name: "en-VG", value: "en-VG" },
			{ name: "fr-VG", value: "fr-VG" },
			{ name: "es-VG", value: "es-VG" },
			{ name: "zh-VG", value: "zh-VG" },
			{ name: "en-BN", value: "en-BN" },
			{ name: "en-BG", value: "en-BG" },
			{ name: "fr-BF", value: "fr-BF" },
			{ name: "en-BF", value: "en-BF" },
			{ name: "es-BF", value: "es-BF" },
			{ name: "zh-BF", value: "zh-BF" },
			{ name: "fr-BI", value: "fr-BI" },
			{ name: "en-BI", value: "en-BI" },
			{ name: "es-BI", value: "es-BI" },
			{ name: "zh-BI", value: "zh-BI" },
			{ name: "en-KH", value: "en-KH" },
			{ name: "fr-CM", value: "fr-CM" },
			{ name: "en-CM", value: "en-CM" },
			{ name: "en-CA", value: "en-CA" },
			{ name: "fr-CA", value: "fr-CA" },
			{ name: "en-CV", value: "en-CV" },
			{ name: "fr-CV", value: "fr-CV" },
			{ name: "es-CV", value: "es-CV" },
			{ name: "zh-CV", value: "zh-CV" },
			{ name: "en-KY", value: "en-KY" },
			{ name: "fr-KY", value: "fr-KY" },
			{ name: "es-KY", value: "es-KY" },
			{ name: "zh-KY", value: "zh-KY" },
			{ name: "fr-TD", value: "fr-TD" },
			{ name: "en-TD", value: "en-TD" },
			{ name: "es-TD", value: "es-TD" },
			{ name: "zh-TD", value: "zh-TD" },
			{ name: "es-CL", value: "es-CL" },
			{ name: "en-CL", value: "en-CL" },
			{ name: "fr-CL", value: "fr-CL" },
			{ name: "zh-CL", value: "zh-CL" },
			{ name: "zh-CN", value: "zh-CN" },
			{ name: "zh-CN", value: "zh-CN" },
			{ name: "en-CN", value: "en-CN" },
			{ name: "es-CO", value: "es-CO" },
			{ name: "en-CO", value: "en-CO" },
			{ name: "fr-CO", value: "fr-CO" },
			{ name: "zh-CO", value: "zh-CO" },
			{ name: "fr-KM", value: "fr-KM" },
			{ name: "en-KM", value: "en-KM" },
			{ name: "es-KM", value: "es-KM" },
			{ name: "zh-KM", value: "zh-KM" },
			{ name: "en-CG", value: "en-CG" },
			{ name: "fr-CG", value: "fr-CG" },
			{ name: "es-CG", value: "es-CG" },
			{ name: "zh-CG", value: "zh-CG" },
			{ name: "fr-CD", value: "fr-CD" },
			{ name: "en-CD", value: "en-CD" },
			{ name: "es-CD", value: "es-CD" },
			{ name: "zh-CD", value: "zh-CD" },
			{ name: "en-CK", value: "en-CK" },
			{ name: "fr-CK", value: "fr-CK" },
			{ name: "es-CK", value: "es-CK" },
			{ name: "zh-CK", value: "zh-CK" },
			{ name: "es-CR", value: "es-CR" },
			{ name: "en-CR", value: "en-CR" },
			{ name: "fr-CR", value: "fr-CR" },
			{ name: "zh-CR", value: "zh-CR" },
			{ name: "fr-CI", value: "fr-CI" },
			{ name: "en-CI", value: "en-CI" },
			{ name: "en-HR", value: "en-HR" },
			{ name: "en-CY", value: "en-CY" },
			{ name: "cs-CZ", value: "cs-CZ" },
			{ name: "en-CZ", value: "en-CZ" },
			{ name: "fr-CZ", value: "fr-CZ" },
			{ name: "es-CZ", value: "es-CZ" },
			{ name: "zh-CZ", value: "zh-CZ" },
			{ name: "da-DK", value: "da-DK" },
			{ name: "en-DK", value: "en-DK" },
			{ name: "fr-DJ", value: "fr-DJ" },
			{ name: "en-DJ", value: "en-DJ" },
			{ name: "es-DJ", value: "es-DJ" },
			{ name: "zh-DJ", value: "zh-DJ" },
			{ name: "en-DM", value: "en-DM" },
			{ name: "fr-DM", value: "fr-DM" },
			{ name: "es-DM", value: "es-DM" },
			{ name: "zh-DM", value: "zh-DM" },
			{ name: "es-DO", value: "es-DO" },
			{ name: "en-DO", value: "en-DO" },
			{ name: "fr-DO", value: "fr-DO" },
			{ name: "zh-DO", value: "zh-DO" },
			{ name: "es-EC", value: "es-EC" },
			{ name: "en-EC", value: "en-EC" },
			{ name: "fr-EC", value: "fr-EC" },
			{ name: "zh-EC", value: "zh-EC" },
			{ name: "ar-EG", value: "ar-EG" },
			{ name: "en-EG", value: "en-EG" },
			{ name: "fr-EG", value: "fr-EG" },
			{ name: "es-EG", value: "es-EG" },
			{ name: "zh-EG", value: "zh-EG" },
			{ name: "es-SV", value: "es-SV" },
			{ name: "en-SV", value: "en-SV" },
			{ name: "fr-SV", value: "fr-SV" },
			{ name: "zh-SV", value: "zh-SV" },
			{ name: "en-ER", value: "en-ER" },
			{ name: "fr-ER", value: "fr-ER" },
			{ name: "es-ER", value: "es-ER" },
			{ name: "zh-ER", value: "zh-ER" },
			{ name: "en-EE", value: "en-EE" },
			{ name: "ru-EE", value: "ru-EE" },
			{ name: "fr-EE", value: "fr-EE" },
			{ name: "es-EE", value: "es-EE" },
			{ name: "zh-EE", value: "zh-EE" },
			{ name: "en-ET", value: "en-ET" },
			{ name: "fr-ET", value: "fr-ET" },
			{ name: "es-ET", value: "es-ET" },
			{ name: "zh-ET", value: "zh-ET" },
			{ name: "en-FK", value: "en-FK" },
			{ name: "fr-FK", value: "fr-FK" },
			{ name: "es-FK", value: "es-FK" },
			{ name: "zh-FK", value: "zh-FK" },
			{ name: "da-FO", value: "da-FO" },
			{ name: "en-FO", value: "en-FO" },
			{ name: "fr-FO", value: "fr-FO" },
			{ name: "es-FO", value: "es-FO" },
			{ name: "zh-FO", value: "zh-FO" },
			{ name: "en-FJ", value: "en-FJ" },
			{ name: "fr-FJ", value: "fr-FJ" },
			{ name: "es-FJ", value: "es-FJ" },
			{ name: "zh-FJ", value: "zh-FJ" },
			{ name: "fi-FI", value: "fi-FI" },
			{ name: "en-FI", value: "en-FI" },
			{ name: "fr-FI", value: "fr-FI" },
			{ name: "es-FI", value: "es-FI" },
			{ name: "zh-FI", value: "zh-FI" },
			{ name: "fr-FR", value: "fr-FR" },
			{ name: "en-FR", value: "en-FR" },
			{ name: "en-GF", value: "en-GF" },
			{ name: "fr-GF", value: "fr-GF" },
			{ name: "es-GF", value: "es-GF" },
			{ name: "zh-GF", value: "zh-GF" },
			{ name: "en-PF", value: "en-PF" },
			{ name: "fr-PF", value: "fr-PF" },
			{ name: "es-PF", value: "es-PF" },
			{ name: "zh-PF", value: "zh-PF" },
			{ name: "fr-GA", value: "fr-GA" },
			{ name: "en-GA", value: "en-GA" },
			{ name: "es-GA", value: "es-GA" },
			{ name: "zh-GA", value: "zh-GA" },
			{ name: "en-GM", value: "en-GM" },
			{ name: "fr-GM", value: "fr-GM" },
			{ name: "es-GM", value: "es-GM" },
			{ name: "zh-GM", value: "zh-GM" },
			{ name: "en-GE", value: "en-GE" },
			{ name: "fr-GE", value: "fr-GE" },
			{ name: "es-GE", value: "es-GE" },
			{ name: "zh-GE", value: "zh-GE" },
			{ name: "de-DE", value: "de-DE" },
			{ name: "en-DE", value: "en-DE" },
			{ name: "en-GI", value: "en-GI" },
			{ name: "fr-GI", value: "fr-GI" },
			{ name: "es-GI", value: "es-GI" },
			{ name: "zh-GI", value: "zh-GI" },
			{ name: "el-GR", value: "el-GR" },
			{ name: "en-GR", value: "en-GR" },
			{ name: "fr-GR", value: "fr-GR" },
			{ name: "es-GR", value: "es-GR" },
			{ name: "zh-GR", value: "zh-GR" },
			{ name: "da-GL", value: "da-GL" },
			{ name: "en-GL", value: "en-GL" },
			{ name: "fr-GL", value: "fr-GL" },
			{ name: "es-GL", value: "es-GL" },
			{ name: "zh-GL", value: "zh-GL" },
			{ name: "en-GD", value: "en-GD" },
			{ name: "fr-GD", value: "fr-GD" },
			{ name: "es-GD", value: "es-GD" },
			{ name: "zh-GD", value: "zh-GD" },
			{ name: "en-GP", value: "en-GP" },
			{ name: "fr-GP", value: "fr-GP" },
			{ name: "es-GP", value: "es-GP" },
			{ name: "zh-GP", value: "zh-GP" },
			{ name: "es-GT", value: "es-GT" },
			{ name: "en-GT", value: "en-GT" },
			{ name: "fr-GT", value: "fr-GT" },
			{ name: "zh-GT", value: "zh-GT" },
			{ name: "fr-GN", value: "fr-GN" },
			{ name: "en-GN", value: "en-GN" },
			{ name: "es-GN", value: "es-GN" },
			{ name: "zh-GN", value: "zh-GN" },
			{ name: "en-GW", value: "en-GW" },
			{ name: "fr-GW", value: "fr-GW" },
			{ name: "es-GW", value: "es-GW" },
			{ name: "zh-GW", value: "zh-GW" },
			{ name: "en-GY", value: "en-GY" },
			{ name: "fr-GY", value: "fr-GY" },
			{ name: "es-GY", value: "es-GY" },
			{ name: "zh-GY", value: "zh-GY" },
			{ name: "es-HN", value: "es-HN" },
			{ name: "en-HN", value: "en-HN" },
			{ name: "fr-HN", value: "fr-HN" },
			{ name: "zh-HN", value: "zh-HN" },
			{ name: "hu-HU", value: "hu-HU" },
			{ name: "en-HU", value: "en-HU" },
			{ name: "fr-HU", value: "fr-HU" },
			{ name: "es-HU", value: "es-HU" },
			{ name: "zh-HU", value: "zh-HU" },
			{ name: "en-IS", value: "en-IS" },
			{ name: "en_IN", value: "en_IN" },
			{ name: "id-ID", value: "id-ID" },
			{ name: "en-ID", value: "en-ID" },
			{ name: "en-IE", value: "en-IE" },
			{ name: "fr-IE", value: "fr-IE" },
			{ name: "es-IE", value: "es-IE" },
			{ name: "zh-IE", value: "zh-IE" },
			{ name: "he-IL", value: "he-IL" },
			{ name: "en-IL", value: "en-IL" },
			{ name: "it-IT", value: "it-IT" },
			{ name: "en-IT", value: "en-IT" },
			{ name: "es-JM", value: "es-JM" },
			{ name: "en-JM", value: "en-JM" },
			{ name: "fr-JM", value: "fr-JM" },
			{ name: "zh-JM", value: "zh-JM" },
			{ name: "ja-JP", value: "ja-JP" },
			{ name: "en-JP", value: "en-JP" },
			{ name: "ar-JO", value: "ar-JO" },
			{ name: "en-JO", value: "en-JO" },
			{ name: "fr-JO", value: "fr-JO" },
			{ name: "es-JO", value: "es-JO" },
			{ name: "zh-JO", value: "zh-JO" },
			{ name: "en-KZ", value: "en-KZ" },
			{ name: "fr-KZ", value: "fr-KZ" },
			{ name: "es-KZ", value: "es-KZ" },
			{ name: "zh-KZ", value: "zh-KZ" },
			{ name: "en-KE", value: "en-KE" },
			{ name: "fr-KE", value: "fr-KE" },
			{ name: "es-KE", value: "es-KE" },
			{ name: "zh-KE", value: "zh-KE" },
			{ name: "en-KI", value: "en-KI" },
			{ name: "fr-KI", value: "fr-KI" },
			{ name: "es-KI", value: "es-KI" },
			{ name: "zh-KI", value: "zh-KI" },
			{ name: "ar-KW", value: "ar-KW" },
			{ name: "en-KW", value: "en-KW" },
			{ name: "fr-KW", value: "fr-KW" },
			{ name: "es-KW", value: "es-KW" },
			{ name: "zh-KW", value: "zh-KW" },
			{ name: "en-KG", value: "en-KG" },
			{ name: "fr-KG", value: "fr-KG" },
			{ name: "es-KG", value: "es-KG" },
			{ name: "zh-KG", value: "zh-KG" },
			{ name: "en-LA", value: "en-LA" },
			{ name: "en-LV", value: "en-LV" },
			{ name: "ru-LV", value: "ru-LV" },
			{ name: "fr-LV", value: "fr-LV" },
			{ name: "es-LV", value: "es-LV" },
			{ name: "zh-LV", value: "zh-LV" },
			{ name: "en-LS", value: "en-LS" },
			{ name: "fr-LS", value: "fr-LS" },
			{ name: "es-LS", value: "es-LS" },
			{ name: "zh-LS", value: "zh-LS" },
			{ name: "en-LI", value: "en-LI" },
			{ name: "fr-LI", value: "fr-LI" },
			{ name: "es-LI", value: "es-LI" },
			{ name: "zh-LI", value: "zh-LI" },
			{ name: "en-LT", value: "en-LT" },
			{ name: "ru-LT", value: "ru-LT" },
			{ name: "fr-LT", value: "fr-LT" },
			{ name: "es-LT", value: "es-LT" },
			{ name: "zh-LT", value: "zh-LT" },
			{ name: "en-LU", value: "en-LU" },
			{ name: "de-LU", value: "de-LU" },
			{ name: "fr-LU", value: "fr-LU" },
			{ name: "es-LU", value: "es-LU" },
			{ name: "zh-LU", value: "zh-LU" },
			{ name: "en-MK", value: "en-MK" },
			{ name: "en-MG", value: "en-MG" },
			{ name: "fr-MG", value: "fr-MG" },
			{ name: "es-MG", value: "es-MG" },
			{ name: "zh-MG", value: "zh-MG" },
			{ name: "en-MW", value: "en-MW" },
			{ name: "fr-MW", value: "fr-MW" },
			{ name: "es-MW", value: "es-MW" },
			{ name: "zh-MW", value: "zh-MW" },
			{ name: "en-MY", value: "en-MY" },
			{ name: "en-MV", value: "en-MV" },
			{ name: "fr-ML", value: "fr-ML" },
			{ name: "en-ML", value: "en-ML" },
			{ name: "es-ML", value: "es-ML" },
			{ name: "zh-ML", value: "zh-ML" },
			{ name: "en-MT", value: "en-MT" },
			{ name: "en-MH", value: "en-MH" },
			{ name: "fr-MH", value: "fr-MH" },
			{ name: "es-MH", value: "es-MH" },
			{ name: "zh-MH", value: "zh-MH" },
			{ name: "en-MQ", value: "en-MQ" },
			{ name: "fr-MQ", value: "fr-MQ" },
			{ name: "es-MQ", value: "es-MQ" },
			{ name: "zh-MQ", value: "zh-MQ" },
			{ name: "en-MR", value: "en-MR" },
			{ name: "fr-MR", value: "fr-MR" },
			{ name: "es-MR", value: "es-MR" },
			{ name: "zh-MR", value: "zh-MR" },
			{ name: "en-MU", value: "en-MU" },
			{ name: "fr-MU", value: "fr-MU" },
			{ name: "es-MU", value: "es-MU" },
			{ name: "zh-MU", value: "zh-MU" },
			{ name: "en-YT", value: "en-YT" },
			{ name: "fr-YT", value: "fr-YT" },
			{ name: "es-YT", value: "es-YT" },
			{ name: "zh-YT", value: "zh-YT" },
			{ name: "es-MX", value: "es-MX" },
			{ name: "en-MX", value: "en-MX" },
			{ name: "en-FM", value: "en-FM" },
			{ name: "en-MD", value: "en-MD" },
			{ name: "fr-MC", value: "fr-MC" },
			{ name: "en-MC", value: "en-MC" },
			{ name: "en-MN", value: "en-MN" },
			{ name: "en-ME", value: "en-ME" },
			{ name: "en-MS", value: "en-MS" },
			{ name: "fr-MS", value: "fr-MS" },
			{ name: "es-MS", value: "es-MS" },
			{ name: "zh-MS", value: "zh-MS" },
			{ name: "ar-MA", value: "ar-MA" },
			{ name: "en-MA", value: "en-MA" },
			{ name: "fr-MA", value: "fr-MA" },
			{ name: "es-MA", value: "es-MA" },
			{ name: "zh-MA", value: "zh-MA" },
			{ name: "en-MZ", value: "en-MZ" },
			{ name: "fr-MZ", value: "fr-MZ" },
			{ name: "es-MZ", value: "es-MZ" },
			{ name: "zh-MZ", value: "zh-MZ" },
			{ name: "en-NA", value: "en-NA" },
			{ name: "fr-NA", value: "fr-NA" },
			{ name: "es-NA", value: "es-NA" },
			{ name: "zh-NA", value: "zh-NA" },
			{ name: "en-NR", value: "en-NR" },
			{ name: "fr-NR", value: "fr-NR" },
			{ name: "es-NR", value: "es-NR" },
			{ name: "zh-NR", value: "zh-NR" },
			{ name: "en-NP", value: "en-NP" },
			{ name: "nl-NL", value: "nl-NL" },
			{ name: "en-NL", value: "en-NL" },
			{ name: "en-NC", value: "en-NC" },
			{ name: "fr-NC", value: "fr-NC" },
			{ name: "es-NC", value: "es-NC" },
			{ name: "zh-NC", value: "zh-NC" },
			{ name: "en-NZ", value: "en-NZ" },
			{ name: "fr-NZ", value: "fr-NZ" },
			{ name: "es-NZ", value: "es-NZ" },
			{ name: "zh-NZ", value: "zh-NZ" },
			{ name: "es-NI", value: "es-NI" },
			{ name: "en-NI", value: "en-NI" },
			{ name: "fr-NI", value: "fr-NI" },
			{ name: "zh-NI", value: "zh-NI" },
			{ name: "fr-NE", value: "fr-NE" },
			{ name: "en-NE", value: "en-NE" },
			{ name: "es-NE", value: "es-NE" },
			{ name: "zh-NE", value: "zh-NE" },
			{ name: "en-NG", value: "en-NG" },
			{ name: "en-NU", value: "en-NU" },
			{ name: "fr-NU", value: "fr-NU" },
			{ name: "es-NU", value: "es-NU" },
			{ name: "zh-NU", value: "zh-NU" },
			{ name: "en-NF", value: "en-NF" },
			{ name: "fr-NF", value: "fr-NF" },
			{ name: "es-NF", value: "es-NF" },
			{ name: "zh-NF", value: "zh-NF" },
			{ name: "no-NO", value: "no-NO" },
			{ name: "en-NO", value: "en-NO" },
			{ name: "ar-OM", value: "ar-OM" },
			{ name: "en-OM", value: "en-OM" },
			{ name: "fr-OM", value: "fr-OM" },
			{ name: "es-OM", value: "es-OM" },
			{ name: "zh-OM", value: "zh-OM" },
			{ name: "en-PW", value: "en-PW" },
			{ name: "fr-PW", value: "fr-PW" },
			{ name: "es-PW", value: "es-PW" },
			{ name: "zh-PW", value: "zh-PW" },
			{ name: "es-PA", value: "es-PA" },
			{ name: "en-PA", value: "en-PA" },
			{ name: "fr-PA", value: "fr-PA" },
			{ name: "zh-PA", value: "zh-PA" },
			{ name: "en-PG", value: "en-PG" },
			{ name: "fr-PG", value: "fr-PG" },
			{ name: "es-PG", value: "es-PG" },
			{ name: "zh-PG", value: "zh-PG" },
			{ name: "es-PY", value: "es-PY" },
			{ name: "en-PY", value: "en-PY" },
			{ name: "es-PE", value: "es-PE" },
			{ name: "en-PE", value: "en-PE" },
			{ name: "fr-PE", value: "fr-PE" },
			{ name: "zh-PE", value: "zh-PE" },
			{ name: "en-PH", value: "en-PH" },
			{ name: "en-PN", value: "en-PN" },
			{ name: "fr-PN", value: "fr-PN" },
			{ name: "es-PN", value: "es-PN" },
			{ name: "zh-PN", value: "zh-PN" },
			{ name: "pl-PL", value: "pl-PL" },
			{ name: "en-PL", value: "en-PL" },
			{ name: "pt-PT", value: "pt-PT" },
			{ name: "en-PT", value: "en-PT" },
			{ name: "en-QA", value: "en-QA" },
			{ name: "fr-QA", value: "fr-QA" },
			{ name: "es-QA", value: "es-QA" },
			{ name: "zh-QA", value: "zh-QA" },
			{ name: "ar-QA", value: "ar-QA" },
			{ name: "en-RE", value: "en-RE" },
			{ name: "fr-RE", value: "fr-RE" },
			{ name: "es-RE", value: "es-RE" },
			{ name: "zh-RE", value: "zh-RE" },
			{ name: "en-RO", value: "en-RO" },
			{ name: "fr-RO", value: "fr-RO" },
			{ name: "es-RO", value: "es-RO" },
			{ name: "zh-RO", value: "zh-RO" },
			{ name: "ru-RU", value: "ru-RU" },
			{ name: "en-RU", value: "en-RU" },
			{ name: "fr-RW", value: "fr-RW" },
			{ name: "en-RW", value: "en-RW" },
			{ name: "es-RW", value: "es-RW" },
			{ name: "zh-RW", value: "zh-RW" },
			{ name: "en-WS", value: "en-WS" },
			{ name: "en-SM", value: "en-SM" },
			{ name: "fr-SM", value: "fr-SM" },
			{ name: "es-SM", value: "es-SM" },
			{ name: "zh-SM", value: "zh-SM" },
			{ name: "en-ST", value: "en-ST" },
			{ name: "fr-ST", value: "fr-ST" },
			{ name: "es-ST", value: "es-ST" },
			{ name: "zh-ST", value: "zh-ST" },
			{ name: "ar-SA", value: "ar-SA" },
			{ name: "en-SA", value: "en-SA" },
			{ name: "fr-SA", value: "fr-SA" },
			{ name: "es-SA", value: "es-SA" },
			{ name: "zh-SA", value: "zh-SA" },
			{ name: "fr-SN", value: "fr-SN" },
			{ name: "en-SN", value: "en-SN" },
			{ name: "es-SN", value: "es-SN" },
			{ name: "zh-SN", value: "zh-SN" },
			{ name: "en-RS", value: "en-RS" },
			{ name: "fr-RS", value: "fr-RS" },
			{ name: "es-RS", value: "es-RS" },
			{ name: "zh-RS", value: "zh-RS" },
			{ name: "fr-SC", value: "fr-SC" },
			{ name: "en-SC", value: "en-SC" },
			{ name: "es-SC", value: "es-SC" },
			{ name: "zh-SC", value: "zh-SC" },
			{ name: "en-SL", value: "en-SL" },
			{ name: "fr-SL", value: "fr-SL" },
			{ name: "es-SL", value: "es-SL" },
			{ name: "zh-SL", value: "zh-SL" },
			{ name: "en-SG", value: "en-SG" },
			{ name: "sk-SK", value: "sk-SK" },
			{ name: "en-SK", value: "en-SK" },
			{ name: "fr-SK", value: "fr-SK" },
			{ name: "es-SK", value: "es-SK" },
			{ name: "zh-SK", value: "zh-SK" },
			{ name: "en-SI", value: "en-SI" },
			{ name: "fr-SI", value: "fr-SI" },
			{ name: "es-SI", value: "es-SI" },
			{ name: "zh-SI", value: "zh-SI" },
			{ name: "en-SB", value: "en-SB" },
			{ name: "fr-SB", value: "fr-SB" },
			{ name: "es-SB", value: "es-SB" },
			{ name: "zh-SB", value: "zh-SB" },
			{ name: "en-SO", value: "en-SO" },
			{ name: "fr-SO", value: "fr-SO" },
			{ name: "es-SO", value: "es-SO" },
			{ name: "zh-SO", value: "zh-SO" },
			{ name: "en-ZA", value: "en-ZA" },
			{ name: "fr-ZA", value: "fr-ZA" },
			{ name: "es-ZA", value: "es-ZA" },
			{ name: "zh-ZA", value: "zh-ZA" },
			{ name: "ko-KR", value: "ko-KR" },
			{ name: "en-KR", value: "en-KR" },
			{ name: "es-ES", value: "es-ES" },
			{ name: "en-ES", value: "en-ES" },
			{ name: "en-LK", value: "en-LK" },
			{ name: "en-SH", value: "en-SH" },
			{ name: "fr-SH", value: "fr-SH" },
			{ name: "es-SH", value: "es-SH" },
			{ name: "zh-SH", value: "zh-SH" },
			{ name: "en-KN", value: "en-KN" },
			{ name: "fr-KN", value: "fr-KN" },
			{ name: "es-KN", value: "es-KN" },
			{ name: "zh-KN", value: "zh-KN" },
			{ name: "en-LC", value: "en-LC" },
			{ name: "fr-LC", value: "fr-LC" },
			{ name: "es-LC", value: "es-LC" },
			{ name: "zh-LC", value: "zh-LC" },
			{ name: "en-PM", value: "en-PM" },
			{ name: "fr-PM", value: "fr-PM" },
			{ name: "es-PM", value: "es-PM" },
			{ name: "zh-PM", value: "zh-PM" },
			{ name: "en-VC", value: "en-VC" },
			{ name: "fr-VC", value: "fr-VC" },
			{ name: "es-VC", value: "es-VC" },
			{ name: "zh-VC", value: "zh-VC" },
			{ name: "en-SR", value: "en-SR" },
			{ name: "fr-SR", value: "fr-SR" },
			{ name: "es-SR", value: "es-SR" },
			{ name: "zh-SR", value: "zh-SR" },
			{ name: "en-SJ", value: "en-SJ" },
			{ name: "fr-SJ", value: "fr-SJ" },
			{ name: "es-SJ", value: "es-SJ" },
			{ name: "zh-SJ", value: "zh-SJ" },
			{ name: "en-SZ", value: "en-SZ" },
			{ name: "fr-SZ", value: "fr-SZ" },
			{ name: "es-SZ", value: "es-SZ" },
			{ name: "zh-SZ", value: "zh-SZ" },
			{ name: "sv-SE", value: "sv-SE" },
			{ name: "en-SE", value: "en-SE" },
			{ name: "de-CH", value: "de-CH" },
			{ name: "fr-CH", value: "fr-CH" },
			{ name: "en-CH", value: "en-CH" },
			{ name: "zh-TW", value: "zh-TW" },
			{ name: "en-TW", value: "en-TW" },
			{ name: "en-TJ", value: "en-TJ" },
			{ name: "fr-TJ", value: "fr-TJ" },
			{ name: "es-TJ", value: "es-TJ" },
			{ name: "zh-TJ", value: "zh-TJ" },
			{ name: "en-TZ", value: "en-TZ" },
			{ name: "fr-TZ", value: "fr-TZ" },
			{ name: "es-TZ", value: "es-TZ" },
			{ name: "zh-TZ", value: "zh-TZ" },
			{ name: "th-TH", value: "th-TH" },
			{ name: "en-TH", value: "en-TH" },
			{ name: "fr-TG", value: "fr-TG" },
			{ name: "en-TG", value: "en-TG" },
			{ name: "es-TG", value: "es-TG" },
			{ name: "zh-TG", value: "zh-TG" },
			{ name: "en-TO", value: "en-TO" },
			{ name: "en-TT", value: "en-TT" },
			{ name: "fr-TT", value: "fr-TT" },
			{ name: "es-TT", value: "es-TT" },
			{ name: "zh-TT", value: "zh-TT" },
			{ name: "ar-TN", value: "ar-TN" },
			{ name: "en-TN", value: "en-TN" },
			{ name: "fr-TN", value: "fr-TN" },
			{ name: "es-TN", value: "es-TN" },
			{ name: "zh-TN", value: "zh-TN" },
			{ name: "en-TM", value: "en-TM" },
			{ name: "fr-TM", value: "fr-TM" },
			{ name: "es-TM", value: "es-TM" },
			{ name: "zh-TM", value: "zh-TM" },
			{ name: "en-TC", value: "en-TC" },
			{ name: "fr-TC", value: "fr-TC" },
			{ name: "es-TC", value: "es-TC" },
			{ name: "zh-TC", value: "zh-TC" },
			{ name: "en-TV", value: "en-TV" },
			{ name: "fr-TV", value: "fr-TV" },
			{ name: "es-TV", value: "es-TV" },
			{ name: "zh-TV", value: "zh-TV" },
			{ name: "en-UG", value: "en-UG" },
			{ name: "fr-UG", value: "fr-UG" },
			{ name: "es-UG", value: "es-UG" },
			{ name: "zh-UG", value: "zh-UG" },
			{ name: "en-UA", value: "en-UA" },
			{ name: "ru-UA", value: "ru-UA" },
			{ name: "fr-UA", value: "fr-UA" },
			{ name: "es-UA", value: "es-UA" },
			{ name: "zh-UA", value: "zh-UA" },
			{ name: "en-AE", value: "en-AE" },
			{ name: "fr-AE", value: "fr-AE" },
			{ name: "es-AE", value: "es-AE" },
			{ name: "zh-AE", value: "zh-AE" },
			{ name: "ar-AE", value: "ar-AE" },
			{ name: "en-GB", value: "en-GB" },
			{ name: "fr-US", value: "fr-US" },
			{ name: "es-US", value: "es-US" },
			{ name: "zh-US", value: "zh-US" },
			{ name: "es-UY", value: "es-UY" },
			{ name: "en-UY", value: "en-UY" },
			{ name: "fr-UY", value: "fr-UY" },
			{ name: "zh-UY", value: "zh-UY" },
			{ name: "en-VU", value: "en-VU" },
			{ name: "fr-VU", value: "fr-VU" },
			{ name: "es-VU", value: "es-VU" },
			{ name: "zh-VU", value: "zh-VU" },
			{ name: "en-VA", value: "en-VA" },
			{ name: "fr-VA", value: "fr-VA" },
			{ name: "es-VA", value: "es-VA" },
			{ name: "zh-VA", value: "zh-VA" },
			{ name: "es-VE", value: "es-VE" },
			{ name: "en-VE", value: "en-VE" },
			{ name: "fr-VE", value: "fr-VE" },
			{ name: "zh-VE", value: "zh-VE" },
			{ name: "en-VN", value: "en-VN" },
			{ name: "en-WF", value: "en-WF" },
			{ name: "fr-WF", value: "fr-WF" },
			{ name: "es-WF", value: "es-WF" },
			{ name: "zh-WF", value: "zh-WF" },
			{ name: "ar-YE", value: "ar-YE" },
			{ name: "en-YE", value: "en-YE" },
			{ name: "fr-YE", value: "fr-YE" },
			{ name: "es-YE", value: "es-YE" },
			{ name: "zh-YE", value: "zh-YE" },
			{ name: "en-ZM", value: "en-ZM" },
			{ name: "fr-ZM", value: "fr-ZM" },
			{ name: "es-ZM", value: "es-ZM" },
			{ name: "zh-ZM", value: "zh-ZM" },
			{ name: "en-ZW", value: "en-ZW" }
		],

		currencyCodesDictionary: {
			ADP: "ADP",
			AED: "AED",
			AFA: "AFA",
			AFN: "AFN",
			ALK: "ALK",
			ALL: "ALL",
			AMD: "AMD",
			ANG: "ANG",
			AOA: "AOA",
			AOK: "AOK",
			AON: "AON",
			AOR: "AOR",
			ARA: "ARA",
			ARP: "ARP",
			ARS: "ARS",
			ARY: "ARY",
			ATS: "ATS",
			AUD: "AUD",
			AWG: "AWG",
			AYM: "AYM",
			AZM: "AZM",
			AZN: "AZN",
			BAD: "BAD",
			BAM: "BAM",
			BBD: "BBD",
			BDT: "BDT",
			BEC: "BEC",
			BEF: "BEF",
			BEL: "BEL",
			BGJ: "BGJ",
			BGK: "BGK",
			BGL: "BGL",
			BGN: "BGN",
			BHD: "BHD",
			BIF: "BIF",
			BMD: "BMD",
			BND: "BND",
			BOB: "BOB",
			BOP: "BOP",
			BOV: "BOV",
			BRB: "BRB",
			BRC: "BRC",
			BRE: "BRE",
			BRL: "BRL",
			BRN: "BRN",
			BRR: "BRR",
			BSD: "BSD",
			BTN: "BTN",
			BUK: "BUK",
			BWP: "BWP",
			BYB: "BYB",
			BYN: "BYN",
			BYR: "BYR",
			BZD: "BZD",
			CAD: "CAD",
			CDF: "CDF",
			CHC: "CHC",
			CHE: "CHE",
			CHF: "CHF",
			CHW: "CHW",
			CLF: "CLF",
			CLP: "CLP",
			CNX: "CNX",
			CNY: "CNY",
			COP: "COP",
			COU: "COU",
			CRC: "CRC",
			CSD: "CSD",
			CSJ: "CSJ",
			CSK: "CSK",
			CUC: "CUC",
			CUP: "CUP",
			CVE: "CVE",
			CYP: "CYP",
			CZK: "CZK",
			DDM: "DDM",
			DEM: "DEM",
			DJF: "DJF",
			DKK: "DKK",
			DOP: "DOP",
			DZD: "DZD",
			ECS: "ECS",
			ECV: "ECV",
			EEK: "EEK",
			EGP: "EGP",
			ERN: "ERN",
			ESA: "ESA",
			ESB: "ESB",
			ESP: "ESP",
			ETB: "ETB",
			EUR: "EUR",
			FIM: "FIM",
			FJD: "FJD",
			FKP: "FKP",
			FRF: "FRF",
			GBP: "GBP",
			GEK: "GEK",
			GEL: "GEL",
			GHC: "GHC",
			GHP: "GHP",
			GHS: "GHS",
			GIP: "GIP",
			GMD: "GMD",
			GNE: "GNE",
			GNF: "GNF",
			GNS: "GNS",
			GQE: "GQE",
			GRD: "GRD",
			GTQ: "GTQ",
			GWE: "GWE",
			GWP: "GWP",
			GYD: "GYD",
			HKD: "HKD",
			HNL: "HNL",
			HRD: "HRD",
			HRK: "HRK",
			HTG: "HTG",
			HUF: "HUF",
			IDR: "IDR",
			IEP: "IEP",
			ILP: "ILP",
			ILR: "ILR",
			ILS: "ILS",
			INR: "INR",
			IQD: "IQD",
			IRR: "IRR",
			ISJ: "ISJ",
			ISK: "ISK",
			ITL: "ITL",
			JMD: "JMD",
			JOD: "JOD",
			JPY: "JPY",
			KES: "KES",
			KGS: "KGS",
			KHR: "KHR",
			KMF: "KMF",
			KPW: "KPW",
			KRW: "KRW",
			KWD: "KWD",
			KYD: "KYD",
			KZT: "KZT",
			LAJ: "LAJ",
			LAK: "LAK",
			LBP: "LBP",
			LKR: "LKR",
			LRD: "LRD",
			LSL: "LSL",
			LSM: "LSM",
			LTL: "LTL",
			LTT: "LTT",
			LUC: "LUC",
			LUF: "LUF",
			LUL: "LUL",
			LVL: "LVL",
			LVR: "LVR",
			LYD: "LYD",
			MAD: "MAD",
			MDL: "MDL",
			MGA: "MGA",
			MGF: "MGF",
			MKD: "MKD",
			MLF: "MLF",
			MMK: "MMK",
			MNT: "MNT",
			MOP: "MOP",
			MRO: "MRO",
			MTL: "MTL",
			MTP: "MTP",
			MUR: "MUR",
			MVQ: "MVQ",
			MVR: "MVR",
			MWK: "MWK",
			MXN: "MXN",
			MXV: "MXV",
			MYR: "MYR",
			MZE: "MZE",
			MZM: "MZM",
			MZN: "MZN",
			NAD: "NAD",
			NGN: "NGN",
			NIC: "NIC",
			NIO: "NIO",
			NLG: "NLG",
			NOK: "NOK",
			NPR: "NPR",
			NZD: "NZD",
			OMR: "OMR",
			PAB: "PAB",
			PEH: "PEH",
			PEI: "PEI",
			PEN: "PEN",
			PES: "PES",
			PGK: "PGK",
			PHP: "PHP",
			PKR: "PKR",
			PLN: "PLN",
			PLZ: "PLZ",
			PTE: "PTE",
			PYG: "PYG",
			QAR: "QAR",
			RHD: "RHD",
			ROK: "ROK",
			ROL: "ROL",
			RON: "RON",
			RSD: "RSD",
			RUB: "RUB",
			RUR: "RUR",
			RWF: "RWF",
			SAR: "SAR",
			SBD: "SBD",
			SCR: "SCR",
			SDD: "SDD",
			SDG: "SDG",
			SDP: "SDP",
			SEK: "SEK",
			SGD: "SGD",
			SHP: "SHP",
			SIT: "SIT",
			SKK: "SKK",
			SLL: "SLL",
			SOS: "SOS",
			SRD: "SRD",
			SRG: "SRG",
			SSP: "SSP",
			STD: "STD",
			SUR: "SUR",
			SVC: "SVC",
			SYP: "SYP",
			SZL: "SZL",
			THB: "THB",
			TJR: "TJR",
			TJS: "TJS",
			TMM: "TMM",
			TMT: "TMT",
			TND: "TND",
			TOP: "TOP",
			TPE: "TPE",
			TRL: "TRL",
			TRY: "TRY",
			TTD: "TTD",
			TWD: "TWD",
			TZS: "TZS",
			UAH: "UAH",
			UAK: "UAK",
			UGS: "UGS",
			UGW: "UGW",
			UGX: "UGX",
			UNDEFINED: "None",
			USD: "USD",
			USN: "USN",
			USS: "USS",
			UYI: "UYI",
			UYN: "UYN",
			UYP: "UYP",
			UYU: "UYU",
			UZS: "UZS",
			VEB: "VEB",
			VEF: "VEF",
			VNC: "VNC",
			VND: "VND",
			VUV: "VUV",
			WST: "WST",
			XAF: "XAF",
			XAG: "XAG",
			XAU: "XAU",
			XBA: "XBA",
			XBB: "XBB",
			XBC: "XBC",
			XBD: "XBD",
			XCD: "XCD",
			XDR: "XDR",
			XEU: "XEU",
			XFO: "XFO",
			XFU: "XFU",
			XOF: "XOF",
			XPD: "XPD",
			XPF: "XPF",
			XPT: "XPT",
			XRE: "XRE",
			XSU: "XSU",
			XTS: "XTS",
			XUA: "XUA",
			XXX: "XXX",
			YDD: "YDD",
			YER: "YER",
			YUD: "YUD",
			YUM: "YUM",
			YUN: "YUN",
			ZAL: "ZAL",
			ZAR: "ZAR",
			ZMK: "ZMK",
			ZMW: "ZMW",
			ZRN: "ZRN",
			ZRZ: "ZRZ",
			ZWC: "ZWC",
			ZWD: "ZWD",
			ZWL: "ZWL",
			ZWN: "ZWN",
			ZWR: "ZWR"
		}
	},

	messages: {},
	tenantId: null
})
